import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import useLang from "../../hooks/use-lang.hook";

import plusGrayIcon from "../../_assets/vectors/plus-gray-icon.svg";
import { CommunityService } from "../../_service";
import { setActiveGroup, setGroups } from "../../_store/_actions/group.actions";
import I18 from "../atoms/i18";
import { Button } from "../button.component";
import EmojiPicker from "../form-controls/emoji-picker.component";
import IconButton from "../icon-button.component";
import { Loader } from "../loader.component";
import { Modal } from "../modal.component";
import { TextInput } from "../text-input.component";

function CreateCommunityLinkModalComponent({
  user,
  community,
  active = false,
  setActive = (e) => {},
  link = null,
  onLinkAdd = (link) => {},
  onLinkUpdate = (link) => {},
}) {
  const lang = useLang();
  // form states
  const [isFormSubmitable, setIsFormSubmitable] = useState(link ? true : false); // to disable submit button
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState(link ? link.label : "");
  const [emoji, setEmoji] = useState(link ? link.emoji : null);
  const [isEmojiPickerVisible, setIsEmojiPickerVisible] = useState(false);
  const [url, setUrl] = useState(link ? link.url : "");

  // const [errors, setErrors] = useState({});

  const submitForm = (e) => {
    // create section object
    const communityLink = {
      label: name,
      emoji,
      url,
    };

    setIsLoading(true);
    // if editing a link, update it, or create a new
    if (link) {
      CommunityService.editCommunityLink(user, community.id, {
        ...communityLink,
        id: link.id,
      })
        .then(({ link }) => {
          onLinkUpdate(link);
          setIsLoading(false);
          resetFormAndClose();
        })
        .catch((error) => {
          console.log({ error });
          setIsLoading(false);
          resetFormAndClose();
        });
    } else {
      CommunityService.addCommunityLink(user, community.id, communityLink)
        .then(({ link }) => {
          onLinkAdd(link);
          setIsLoading(false);
          resetFormAndClose();
        })
        .catch((error) => {
          console.log({ error });
          setIsLoading(false);
          resetFormAndClose();
        });
    }
    /*        if (link) {
                   // call the edit section api
                   GroupService.editGroupTab(user, activeGroup.id, activeTab.id, tab)
                       .then(({ group }) => {
                           // close the form
                           setIsLoading(false);
                           resetFormAndClose();
                           // update the active group and groups table
                           updateActiveGroup(group);
                       })
                       .catch(err => {
                           setIsLoading(false);
                       })
               } else {
                   // call the create section api
                   GroupService.createGroupTab(user, activeGroup.id, tab)
                       .then(({ group }) => {
                           // close the form
                           setIsLoading(false);
                           resetFormAndClose();
                           // update the active group and groups table
                           updateActiveGroup(group);
                       })
                       .catch(err => {
                           setIsLoading(false);
                       })
       
               } */
  };

  const resetFormAndClose = () => {
    setName("");
    setUrl("");
    setIsFormSubmitable(false);
    setActive(false);
  };

  return (
    <Modal
      className="CreateGroupModal"
      active={active}
      width="390px"
      padding={false}
      setActive={setActive}>
      {/* headers */}
      <div className="pl-4 pr-2 py-2 theme-bg-surface flex items-center justify-between">
        <span className="font-bold">
          {link ? <I18>Update link</I18> : <I18>Create a link</I18>}
        </span>
        <IconButton
          icon={plusGrayIcon}
          rotate={45}
          onClick={() => {
            resetFormAndClose();
          }}
        />
      </div>
      {/* body */}
      <div className="p-5">
        {/* info */}
        <div className="mb-5">
          <div className="font-semibold mt-1">
            <I18>Add shortcut to your most used tools</I18>
          </div>
          <div className="text-xs theme-text-subtitle-1 mt-1">
            <I18>Your website, Instagram Channel, Facebook profile etc</I18>
          </div>
        </div>
        {/* link name */}
        <div className="mb-5">
          <div className="font-bold mb-1 after:content-['*'] after:text-red-500 after:ml-0.5">
            <I18>Link Name</I18>
          </div>
          <TextInput
            placeholder="Link Name"
            prefix={
              <EmojiPicker
                emoji={emoji}
                setEmoji={(emoji) => {
                  // set emoji
                  setEmoji(emoji);
                  // hide picker
                  setIsEmojiPickerVisible(false);
                }}
                visible={isEmojiPickerVisible}
                setVisible={setIsEmojiPickerVisible}
              />
            }
            defaultValue={name}
            validator={(value) => {
              if (value && value.length > 2) {
                setIsFormSubmitable(true);
                return null;
              } else {
                setIsFormSubmitable(false);
                return "Valid link name required!";
              }
            }}
            onChange={(value) => {
              setName(value);
            }}
            large
            noMargin
          />
        </div>
        {/* link url */}
        <div className="mb-5">
          <div className="font-bold mb-1 after:content-['*'] after:text-red-500 after:ml-0.5">
            <I18>Link URL</I18>
          </div>
          <TextInput
            placeholder="Link URL"
            defaultValue={url}
            validator={(value) => {
              if (
                value &&
                value.length > 9 &&
                (value.startsWith("http://") || value.startsWith("https://"))
              ) {
                setIsFormSubmitable(true);
                return null;
              } else {
                setIsFormSubmitable(false);
                return "Valid url required, and make sure you are not missing http:// or https://";
              }
            }}
            onChange={(value) => {
              setUrl(value);
            }}
            large
            noMargin
          />
        </div>
        <div className="mb-5 mt-24">
          <div className="mx-auto">
            {isLoading ? (
              <div className="flex justify-center">
                <Loader />
              </div>
            ) : (
              <Button
                disabled={!isFormSubmitable}
                onClick={submitForm}
                className="p-4 w-full"
                label={link ? "Update link" : "Add link"}
                large
              />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}

const CreateCommunityLinkModal = connect(
  (s) => ({
    user: s.auth,
    activeGroup: s.activeGroup,
    groups: s.groups,
  }),
  (d) =>
    bindActionCreators(
      {
        updateGroups: setGroups,
        updateActiveGroup: setActiveGroup,
      },
      d
    )
)(CreateCommunityLinkModalComponent);

export { CreateCommunityLinkModal };
